export default __webpack_public_path__ + "static/YCombinator-e62bfa8dbf13ffb9582d479df620f112.svg";